<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-toolbar color="#3F3FFF" dark>
          <v-toolbar-title style="color:#000">My Tasks</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon @click="loadTasks()">
            <v-icon style="color:#000">refresh</v-icon>
          </v-btn>
        </v-toolbar>

        <v-list three-line>
          <template v-for="(item, index) in items">
            <v-list-item
              :key="item.title"
              ripple
              @click="actionOnTask(item.action, item.postID)"
            >
                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                    <v-list-item-subtitle>
                        {{ item.text }}
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn icon ripple>
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index + 1 < items.length"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import moment from 'moment'
  import config from '@/config'
  import utils from '../../../utils';
  // import pairingAPIs from '../Pairing/pairingAPIs';
  import PostAPI from '../Post/postApi'
  import influencerAPIs from '../Influencer/influencerAPIs'
  import api from '@/api'
  import { mapState } from 'vuex';

  export default {
    data () {
      return {
        items: []
      }
    },
    mounted() {
      this.loadTasks()
    },
    computed: {
      ...mapState({
        unsubmittedInfluencers: state => state.pairing.unsubmittedInfluencers
      }),
      currentUserID: function () {
        return this.$store.state.user.id
      }
    },
    methods: {
      loadTasks() {
        this.items = [
          // default task for Influencer to submit
          // to do - Only show if the influnecer have assigned campaign or eligible to submit
        ]
        this.checkForApprovedPost()
        this.checkForNewComments()
        this.checkForSubmittedPosts()
        // this.checkForVerifiedPayouts()
        // this.checkForUnverifiedPayouts()
        this.checkForAbuseReportedPosts()
        this.checkForUnsubmittedPosts()
      },
      actionOnTask(task, postID) {
        switch (task) {
          case 'viewApproved':
            this.$router.push({path: '/posts/internal/approved'});
            break;
          case 'viewSubmitted':
            this.$router.push({path: '/posts/internal/pending-kobe'});
            break;
          case 'viewPost':
            this.$router.push({path: '/posts/internal/pending-client', query: { action: 'view', id: postID }});
            break;
          case 'viewAbusePosts':
            this.$router.push({path: '/posts/internal/pending-client'});
            break;
          case 'viewVerifiedCampaigns':
            this.$router.push({path: '/campaigns/all?verified=true'});
            break;
          case 'viewUnsubmittedInfluencers':
            this.$router.push({path: '/posts/draft-submissions-report?date=' + utils.func.formatCustomDate(moment(), 'YYYY-MM-DD')});
            break;
          // case 'viewPayouts':
          //   this.$router.push({path: '/campaignPayoutsInternal'});
          //   break;
        }
      },
      // async checkForVerifiedPayouts() {
      //   const payoutSubmittedPairings = await pairingAPIs.getAllPayoutSubmittedPairings()
      //   let campaigns = [...new Set(payoutSubmittedPairings.map(p => p.campaignID))]
      //   if (campaigns.length > 0) {
      //     this.items.push({
      //       action: 'viewVerifiedCampaigns',
      //       title: 'Verified Campaigns',
      //       text: `${campaigns.length} campaigns(s) verified.`
      //     })
      //   }
      // },
      checkForUnverifiedPayouts() {
        influencerAPIs
          .getAllCampaignPayouts()
          .then(response => {
            let campaignPayouts = response.data
            const unverifiedPayouts = campaignPayouts.filter(element => !element.payoutAmount)
            if (unverifiedPayouts.length > 0) {
              this.items.push({
                action: 'viewPayouts',
                title: 'New payouts found',
                text: `${unverifiedPayouts.length} payout(s) require your verification.`
              })
            }
          })
          .catch(error => {
            // Request failed.
            console.log('error', error)
          })
      },
      checkForAbuseReportedPosts() {
        let status = config.postStatus.CLIENT_PENDING
        PostAPI.getPost({status, page: 1})
          .then(response => {
            let posts = response.posts
            const abuseReportedPosts = posts.filter(post => {
              let reports = post.clientReportAbuse.map(item => item.draftPostId)
              return (reports.includes(post.draftId))
            })
            if (abuseReportedPosts.length > 0) {
              this.items.push({
                action: 'viewAbusePosts',
                title: 'Abuse Reported by Client',
                text: `${abuseReportedPosts.length} post(s) need to revive.`
              })
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      checkForApprovedPost() {
        let status = config.postStatus.APPROVE
        PostAPI.getPost({status, page: 1})
          .then(response => {
            let posts = response.posts
            if (posts.length > 0) {
              this.items.push({
                action: 'viewApproved',
                title: 'Remind Influencer to publish the post',
                text: `${posts.length} scheduled post(s) to publish.`
              })
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      checkForNewComments() {
        // check for new comments and add to Influencer tasks
        // To-Do check by notification type
        api
          .request('get', '/api/v1/notifications', true)
          .then(response => {
            if (response.status !== 200) {
              return;
            }
            response.data.forEach(element => {
              if (!element.readAt) {
                this.items.push({
                  action: 'viewPost',
                  title: element.title,
                  text: element.body,
                  type: element.type,
                  postID: element.postID
                })
              }
            });
          })
          .catch(() => {
            // Request failed.
          });
      },
      checkForSubmittedPosts() {
        let status = config.postStatus.AD_STRATEGIST_PENDING
        PostAPI.getPost({status, page: 1})
          .then(response => {
            let posts = response.posts
            const unAssignedPosts = posts.filter(item => !item.campaignID)
            if (unAssignedPosts.length > 0) {
              this.items.push({
                action: 'viewSubmitted',
                title: 'Assign Campaigns for this posts',
                text: `${unAssignedPosts.length} post(s) to assign the related campaigns.`
              })
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      async checkForUnsubmittedPosts() {
        await this.$store.dispatch('pairing/getPostUnsubmittedPairingInfluencers', {
          date: [utils.func.formatCustomDate(moment(), 'YYYY-MM-DD')]
        })
        this.items.push({
          action: 'viewUnsubmittedInfluencers',
          title: 'Remind Influencer(s) for Content Submissions',
          text: `${this.unsubmittedInfluencers.length} Influencer(s) to submit drafts today`
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ContentStrategistTasks.vue?db1d8318